import React, { useState, useEffect, useRef} from 'react';
import { configData } from "../config";
import { useParams } from 'react-router-dom';
import ReactDOM from "react-dom/client";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import Select from 'react-select';
import './classes/RolodexImpoter.css';

function RolodexImporter() {

   
    const [isLoading, setIsLoading] = useState(true);
    const[error,setError] = useState({});
    const modalContentRef = useRef(null);
    const[success,setSuccess] = useState('');
    const [showEditModal, setShowEditModal] = useState(false);
    const app_url = configData.APP_URL;
    const [selectedFile, setSelectedFile] = useState(null);
    const[sortflagList, setSortflagList] = useState({});
    const[queueList, setQueueList] = useState({});
     const fileInputRef = useRef(null);
    const [importerformData, setImporterFormData] = useState({
      
        sortflags:[],
       
      pageURL: window.location.href, 
      });
  //   const handleChange = event => {
  //   const { name, value} = event.target;
  //   setImporterFormData(prevState => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  
       
     
  //   if(event.target.name === 'sortflags') {
  //     const isChecked = event.target.checked;
  //     if(isChecked){
  //     setImporterFormData(prevState => ({
  //       ...prevState,
  //       sortflags: [...importerformData.sortflags, event.target.value],
        
  //     }));
  //   } else {
  //     let index = importerformData.sortflags.indexOf(event.target.value);
  //     importerformData.sortflags.splice(index, 1);
  //     setImporterFormData(prevState => ({
  //       ...prevState,
  //       sortflags: importerformData.sortflags,
        
  //     }));
  //   }
  //   }
   
  // };
  const handleChange = (event) => {
  const { name, value, checked } = event.target;

  if (name === "sortflags") {
    setImporterFormData((prevState) => {
      if (checked) {
        return {
          ...prevState,
          sortflags: [...prevState.sortflags, value],
        };
      } else {
        return {
          ...prevState,
          sortflags: prevState.sortflags.filter(
            (flag) => flag !== value
          ),
        };
      }
    });
  }
};

   const initialForm = {
      fname:'',
      lname:'',
      email:'',
      phone:'',
      org:'',
      event_log:'',
      sortflags:[] 
    };
      
    const [formData, setFormData] = useState(initialForm);
     const handleModalChange = event => {
    const { name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));};
      const handleSortFlagFocusChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, sortflags: selectedValues }));
    };
  async function  retrieveSortFlags() {
    
   try {
    //  setIsLoading(true);
    const response = await fetch(
      app_url+'sortflag/getsortflaglist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setSortflagList(responsedata.data.result);
    }
  }  catch (error) {
            console.error('Error fetching data:', error);
          // } finally {
          //   setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  }
  async function  retrieveQueuelist() {
    
   try {
    //  setIsLoading(true);
    const response = await fetch(
      app_url+'importer/getrolodexqueue',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setQueueList(responsedata.data.result);
    }
  }  catch (error) {
            console.error('Error fetching data:', error);
          // } finally {
          //   setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  }
      const handleEditModalOpen = () => {
  setShowEditModal(true);
};

const handleEditModalClose = () => {
  setShowEditModal(false);
};
const isValidBasicPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
  return cleaned.length >= 7 && cleaned.length <= 15;
};

const validate = (formData) => {
  const newErrors = {};

   if (!formData.fname?.trim()) {
    newErrors.fname = 'First Name is required';
  }
   if (!formData.lname?.trim()) {
    newErrors.lname = 'Last Name is required';
  }
  // Email
  if (!formData.email?.trim()) {
    newErrors.email = 'Email is required';
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = 'Invalid email format';
  }

  // Phone
  if (formData.phone?.trim()) {
    if (!isValidBasicPhone(formData.phone)) {
      newErrors.phone = 'Invalid Phone Number';
    }
  }
  return newErrors;
};
      const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
      };
        const handleUpload = async () => {
          if (!selectedFile) {
            alert('Please select a CSV file first.');
            return;
          }

      const formData = new FormData();
      formData.append('csvFile', selectedFile); // 'csvFile' is the key expected by your backend
      formData.append('importerformData', JSON.stringify(importerformData));
      try {
        setIsLoading(true);
        const response = await fetch( app_url+'importer/rolodeximport', {
          method: 'POST',
          body: formData, // Send the FormData object
        });

        if (response.ok) {
          const result = await response.json();
          console.log('Upload successful:', result);
           if(result.data.msg === "Success") {
         
          
          // setImporterFormData(prevState => ({
          //   sortflags:[],
            
          // }));
            setImporterFormData({
          sortflags: [],
          pageURL: window.location.href,
        });
          setIsLoading(false);
          
          setSuccess(result.data.result);
          setQueueList(result.data.list);
          setError({});
          window.scrollTo(0, 0);
          const response = await fetch(app_url+'importer/runrolodexcron', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          });
          const data = await response.json();
         if(data.data.result === "user_created") {
        
           }
        } else {
           setError(result.data.result);
            window.scrollTo(0, 0);
           }
        } else {
          console.error('Upload failed:', response.statusText);
          alert('CSV upload failed.');
        }
      } catch (error) {
        console.error('Error during upload:', error);
        
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
    
    useEffect(() => {
  Promise.all([
    retrieveSortFlags(),
    retrieveQueuelist(),
  ])
  .then(() => {
    setIsLoading(false);
  })
  .catch((error) => {
    console.error('Error:', error);
    setIsLoading(false);
  });
}, []);
      
 const handleModalSubmit = async (e) => {
        e.preventDefault();
        
        const validationErrors = validate(formData);
        setError(validationErrors);
          if (Object.keys(validationErrors).length > 0) {
    modalContentRef.current?.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
        if (Object.keys(validationErrors).length === 0) {
          setError({});
          const response = await fetch(app_url+'importer/singlerolodeximport', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
     
      if(data.data.msg == "Success") {   
                handleEditModalClose();
               setSuccess("Added.");
      } 
       

        }
    };
     return (
       <>
   {isLoading ? (
        <Loading />
      ) : (
        <div id="main">
 
            <div class="left"></div>

            <div class="center left-center rolodex_importer">
                <Helmet><title>Professional Rolodex import</title></Helmet>
                   {Object.keys(error).length > 0 && (
          <div className="set-message-error">
           {Object.keys(error).map((key, index) => {
           return <>{error[key]}<br /></>
          
        })}  
          </div>
        )}
                {success && (
                    <>
                        <div className="set-message-done">
                        <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
                        </div></>
          
                )}
                <h1>Rolodex importer</h1>
                <input type="button" name="add_single_user" id="add_single_user" onClick={handleEditModalOpen} style={{float:"right"}} value="Add Single User"/>
                <div style={{clear:"both"}}></div>
                <div class="messages_details">
<p><b>Files(s) must be CSV and have the following columns:</b></p>
<ul>
    
    <li><strong>Fname </strong>(First Name)</li>
    <li><strong>Lname </strong>(Last Name)</li>
    <li><strong>Email</strong></li>
    

</ul>
<p>&nbsp;</p>
<p><b>The following columns are optional:</b></p>
<ul>
<li><strong>Dt </strong>(Date of App in the format "mm/dd/yyyy")</li>
    <li><strong>Phone</strong></li>
    <li><strong>organization</strong></li>
    <li><strong>event_log</strong></li>
</ul>
    
</div>
 {queueList.length > 0 ? (
      <>
        <div class="page-view-myorder">
          <div class="panel panel-default">
            <div class="panel-heading" style={{background:'#fefefe'}}>
              <b>List of users in queue</b>
                                                                                         
            </div>
            <div class="panel-body" >
              <table class="table table-bordered table-striped"><tr><th>Email</th><th>First Name</th><th>Last Name</th><th>Phone no</th><th>Event Log</th><th>Status</th></tr>
           {queueList.map((item, index) => {
                 return <>
                 <tr>
                    <td>{item['email']}</td>
                    <td>{item['fname']}</td>
                    <td>{item['lname']}</td>
                    <td>{item['phone']}</td>
                    <td>{item['event_log']}</td>
                    <td>{item['status']}</td>
                    
                    </tr>
                    </>
                    
                    })}  
          </table>
          </div>
          </div></div>
          </>
        ) : (
               <> <b>Rolodex Importer:</b> <input type="file" name="file" ref={fileInputRef} accept=".csv" onChange={handleFileChange} />(<a href="/basic/web/rolodex_importer/rolodex_importer_demo.csv">Demo file</a>)&nbsp;&nbsp;&nbsp;
               {/* (<a href="https://docs.google.com/document/d/16bsZQjer0_WXc1_bN7L54w0fLpMmDW9lIqai9K0IY4I/edit?usp=sharing" target="_blank">Instructions</a>) */}
               <br /><br />
                
               
                    {sortflagList.length > 0 && (
                    <>
                        {sortflagList.map((item, index) => {
                 return <>
                    <input type="checkbox"
                     id="sortflags" 
                     name="sortflags" 
                    // value={item['id']} 
                     value={String(item.id)}  
                    checked={importerformData.sortflags.includes(String(item.id))}
                    onChange={handleChange}
                     />{item['name']}&nbsp;&nbsp;
                    </>
                    
                    })}  
                    
          </>
        )}
                    
                    <div className="import_button"><button className="form-submit" onClick={handleUpload}>Import</button></div></>
  )}
                 {showEditModal && (
  <div id="editModal" className="modal view-event-modal edit-modal-all rolodex-modal" ref={modalContentRef}>
    <div className="modal-content">
      <div className="modal-header">
        <h2>Add Single User</h2>
        <span className="close" onClick={handleEditModalClose}>&times;</span>
      </div>
      <div className="modal-body edit-model">
        <form onSubmit={handleModalSubmit}>
        {Object.values(error).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(error)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                                    <div className="full_width">
                                      <div className="left_side">
                                <label htmlFor="rolodex-first-name">First Name:<span className="form-required" title="This field is required.">*</span></label></div>
                                <div className="right_side">
                                <input 
                                    type="text" 
                                    id="rolodex-first-name" 
                                    name="fname" 
                                    value={formData.fname}
                                    onChange={handleModalChange}
                                />
                                </div>
                            </div>
                          <div className="full_width">
                            <div className="left_side">
                              <label htmlFor="rolodex-last-name">Last Name: <span className="form-required" title="This field is required.">*</span></label></div>
                               <div className="right_side">
                              <input type="text" 
                                id="rolodex-last-name" 
                                name="lname" 
                                value={formData.lname} 
                                onChange={handleModalChange}
                              />
                              </div>
                        </div>
                           <div className="full_width">
                            <div className="left_side">
                        <label htmlFor="rolodex-email">Email:<span className="form-required" title="This field is required.">*</span></label></div>
                         <div className="right_side">
                        <input 
                            type="text" 
                            id="rolodex-email" 
                            name="email" 
                            value={formData.email}
                            onChange={handleModalChange}
                        />
                        </div>
                        </div>
                          <div className="full_width">
                             <div className="left_side">
                          <label htmlFor="rolodex-phone">Phone:</label></div>
                           <div className="right_side">
                          <input 
                            type="text" 
                            id="rolodex-phone" 
                            name="phone" 
                            value={formData.phone} 
                            onChange={handleModalChange} 
                          />
                          </div>
                        </div>
                        <div className="full_width">
                           <div className="left_side">
                          <label htmlFor="rolodex-org">Organization:</label></div>
                           <div className="right_side">
                          <input 
                            type="text" 
                            id="rolodex-org" 
                            name="org" 
                            value={formData.org} 
                            onChange={handleModalChange} 
                          />
                          </div>
                        </div>                        
                        <div className="full_width">
                           <div className="left_side">
                          <label htmlFor="rolodex-log">Custom Event Log:</label></div> 
                          <div className="right_side">
                          <input 
                            type="text" 
                            id="rolodex-log" 
                            name="event_log" 
                            value={formData.event_log} 
                            onChange={handleModalChange} 
                          />
                          </div>
                        </div>
                         <div className="full_width">
                           <div className="left_side">
                          <label>Sortflag(s):</label> </div>
                           <div className="">
                          <select 
                              name="sortflags" 
                              multiple={true}
                              size="15" 
                              className="rolodex-form-select"                                      
                              onChange={handleSortFlagFocusChange}
                              value={formData.sortflags || []}
                          >
                              {sortflagList.length > 0 && (
                                  <>
                                      {sortflagList.map((item) => {
                                          return <>
                                              {item['id'] != null && (
                                                  <><option value={item['id']}>{item['name']}</option></>
                                              )}
                                          </>
                                      })}  
                                  </>
                              )}
                          </select>                                 
                        </div>
                        </div>
                        <div style={{clear:"both",textAlign:"center",paddingTop:"20px",paddingBottom:"10px"}}>
                        <input type="submit" name="btn" value="Save"/></div>
        
                </form>
      </div>
    </div>
  </div>
)} 
            </div>
        </div>
        
        )}
    </>
    
      );
      
}
export default RolodexImporter;